'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002427 from "./presto.-Two-Factor-Auth-View$$anon$27.js";
import * as $j_presto$002etypes$0024$0024anon$00244 from "./presto.types$$anon$4.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dId$0024 from "./presto.types$-Credential-Id$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024 from "./presto.types$-Credential-Username$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$26() {
  this.bCh = null;
  this.bC9 = null;
  this.bCa = false;
  this.bCi = null;
  this.bCj = false;
  this.bCm = null;
  this.bCf = null;
  this.bCg = false;
  this.bCb = null;
  this.bCc = false;
  this.bCd = null;
  this.bCe = false;
  this.bCk = false;
  this.bCl = false;
  this.bCh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bCm = "Credential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$26 as $c_Lpresto_TwoFactorAuthView$$anon$26 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$26.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$26;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$26() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$26 as $h_Lpresto_TwoFactorAuthView$$anon$26 };
$h_Lpresto_TwoFactorAuthView$$anon$26.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bCh;
});
$p.M = (function() {
  if ((!this.bCa)) {
    this.bC9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bCa = true;
  }
  return this.bC9;
});
$p.O = (function() {
  if ((!this.bCj)) {
    this.bCi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bCj = true;
  }
  return this.bCi;
});
$p.D = (function() {
  return this.bCm;
});
$p.t = (function() {
  if ((!this.bCg)) {
    this.bCf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bCg = true;
  }
  return this.bCf;
});
$p.N = (function() {
  if ((!this.bCc)) {
    this.bCb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dId$0024.$m_Lpresto_types$CredentialId$().gR(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cz(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gr(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dUsername$0024.$m_Lpresto_types$CredentialUsername$().gS(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bCc = true;
  }
  return this.bCb;
});
$p.Q = (function() {
  if ((!this.bCe)) {
    this.bCd = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002427.$c_Lpresto_TwoFactorAuthView$$anon$27();
    this.bCe = true;
  }
  return this.bCd;
});
$p.v = (function() {
  if ((!this.bCl)) {
    this.bCk = false;
    this.bCl = true;
  }
  return this.bCk;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee201) => ((p) => \u03b4scrutinee201.gp(p)))($j_presto$002etypes$0024$0024anon$00244.$m_Lpresto_types$Credential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$26 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$26, "presto.TwoFactorAuthView$$anon$26", ({
  Sv: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$26 as $d_Lpresto_TwoFactorAuthView$$anon$26 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$26.js.map
